"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateZindex = exports.OverlayContext = void 0;
var react_1 = require("react");
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
/*
 * Provides stacked context of overlays as an array, for example
 * a tooltip may be found placed consiquently inside ['modal', 'popover']
 */
exports.OverlayContext = react_1.createContext([]);
/*
 * Converts overlay context into numeric z-index value
 */
var calculateZindex = function (overlayContext) {
    var overlays = ['drawer', 'modal', 'takeover'];
    var isInOverlay = overlayContext.some(function (item) { return overlays.includes(item); });
    var isInGlobalNav = overlayContext.includes('globalnav');
    if (isInOverlay) {
        return parseInt(tokens_1.default.zIndexOverlay, 10);
    }
    if (isInGlobalNav) {
        return parseInt(tokens_1.default.zIndexGlobalNav, 10);
    }
    return parseInt(tokens_1.default.zIndexPopover, 10);
};
exports.calculateZindex = calculateZindex;
//# sourceMappingURL=OverlayContext.js.map